











































































import Vue, { PropType } from 'vue'
import { mapActions, mapState } from 'vuex'
import { QnaQuestion, QnaFormData } from '~/models/qna/types'
import QnaForm from './QnaForm.vue'
import CRecaptchaText from '~/components/shared/configurable/CRecaptchaText.vue'
import {
  FallbackWidgetRenderResult,
  RecaptchaFormToken
} from '~/models/recaptcha/types'
import { CategoryId } from '~/models/category/types'
import { mapDeps } from '~/plugins/dependency-container/utils'
import QnaService from '~/services/qna/QnaService'
import RecaptchaService from '~/services/recaptcha/RecaptchaService'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { QNA_NS } from '~/store/modules/shared/qna/state'

export default Vue.extend({
  components: {
    QnaForm,
    CRecaptchaText,
    CConfirmationModal
  },
  props: {
    question: { type: Object as PropType<QnaQuestion>, default: () => {} }
  },
  data() {
    return {
      inputsState: {
        categoryState: null
      },
      inputsInvalid: {
        category: null
      },
      loading: false,

      comments: [],
      selectedCategoryId: this.question?.questionCategory
        ? this.question.questionCategory.id
        : CategoryId.CARS,
      showRecaptcha2: false,
      recaptcha2Loaded: false,
      recaptchaToken: null,
      formData: null,
      showDeleteConfirm: false
    }
  },
  computed: {
    ...mapDeps({
      qnaService: QnaService,
      recaptchaService: RecaptchaService
    }),
    ...mapState(QNA_NS, {
      makeAndModelsByCategory: state => state.makeAndModelsByCategory,
      dropdownCategories: state => state.dropdownCategories,
      fuelTypes: state => state.fuelTypes,
      tags: state => state.tags
    }),

    makes() {
      if (
        this.selectedCategoryId &&
        Object.keys(this.makeAndModelsByCategory).length !== 0 &&
        this.makeAndModelsByCategory[this.selectedCategoryId]
      ) {
        return this.makeAndModelsByCategory[this.selectedCategoryId].makes
      }

      return []
    },
    topMakes() {
      if (
        this.selectedCategoryId &&
        Object.keys(this.makeAndModelsByCategory).length !== 0 &&
        this.makeAndModelsByCategory[this.selectedCategoryId]
      ) {
        return this.makeAndModelsByCategory[this.selectedCategoryId].topMakes
      }

      return []
    },
    categoryFuelTypes() {
      if (this.selectedCategoryId && Object.keys(this.fuelTypes).length) {
        return this.fuelTypes[this.selectedCategoryId]
      }
      return null
    },
    categoryTags() {
      if (this.selectedCategoryId && Object.keys(this.tags)) {
        return this.tags[this.selectedCategoryId]
      }
      return null
    }
  },
  // async
  async created() {
    this.handleFetchAllCategories()
    const { questionCategory, questionMake } = this.question || {}
    await this.fetchMakesByCategoryId(
      questionCategory?.id || this.selectedCategoryId
    )
    if (
      questionCategory?.id &&
      questionMake?.id &&
      ![CategoryId.XYMA, CategoryId.PLOT].includes(questionCategory.id)
    ) {
      this.handleFetchModelsByMake(questionCategory.id, questionMake.id)
    }

    const currentYear = new Date().getFullYear()
    const minYear = 1900
    this.yearOptions = [
      {
        value: null,
        text: this.$i18n.t('year::qna_year')
      }
    ].concat(
      new Array(currentYear + 1 - minYear)
        .fill(null)
        .map((_, i) => ({ value: i, text: minYear + i }))
    )
  },
  methods: {
    ...mapActions(QNA_NS, [
      'createQuestion',
      'updateQuestion',
      'fetchMakesByCategoryId',
      'fetchAllCategories',
      'fetchModelsByMake'
    ]),

    handleCategoryChange({ categoryId }: { categoryId: number }) {
      this.selectedCategoryId = categoryId
      if (this.qnaService.isVehicle(categoryId)) {
        this.handleFetchMakesByCategoryId(categoryId)
      }
    },
    setModels(models: []) {
      this.$refs.qnaForm.setModels(models)
    },
    handleMakeChange({
      categoryId,
      value
    }: {
      categoryId: number
      value: number[]
    }) {
      this.handleFetchModelsByMake(categoryId, value[0])
    },
    handleHide(e: Event) {
      if (
        JSON.stringify(this.formData) !==
        JSON.stringify(this.$refs.qnaForm.getFormData())
      ) {
        e.preventDefault()
        this.showDeleteConfirm = true
      } else {
        this.$emit('close')
      }
    },
    handleFormMount() {
      this.formData = this.$refs.qnaForm.getFormData()
    },

    scrollToInvalid(top?: number) {
      if (top) {
        this.$refs.modal.$refs.body.scrollTo(0, top)
        return
      }
      const {
        textState,
        titleState,
        makeState
      } = this.$refs.qnaForm.getInvalidFields()
      if (makeState === false) {
        this.$refs.modal.$refs.body.scrollTo(0, 0)
      } else if (
        textState === false ||
        titleState === false ||
        this.showRecaptcha2
      ) {
        this.$refs.modal.$refs.body.scrollTo(0, 1000)
      }
    },

    async onError(errors) {
      if (errors.recaptcha_token && !this.showRecaptcha2) {
        this.showRecaptcha2 = true
        if (!this.recaptcha2Loaded) {
          this.recaptcha2Loaded = true
          await this.$nextTick()
          const {
            token
          }: FallbackWidgetRenderResult = await this.recaptchaService.renderFallbackWidget(
            'g-recaptcha'
          )

          this.$nextTick(() => this.$refs.modal.$refs.body.scrollTo(0, 1000))
          this.recaptchaToken = {
            v: 2,
            token
          } as RecaptchaFormToken
        }
      }
    },
    async handleSubmit() {
      if (!this.$refs.qnaForm.isFormValid()) {
        this.scrollToInvalid()
        return
      }
      this.loading = true
      try {
        const formData = this.$refs.qnaForm.getFormData()
        if (!this.showRecaptcha2) {
          const action =
            this.placement === formData.id
              ? 'update_question'
              : 'create_question'
          const token = await this.recaptchaService.getToken(action)
          this.recaptchaToken = {
            v: 3,
            token
          }
        }
        formData.recaptchaToken = this.recaptchaToken
        if (formData.id) {
          this.handleUpdateQuestion(formData)
        } else {
          this.handleCreateQuestion(formData)
        }
      } catch (e) {
        this.$logger.captureError(e)
      }
    },
    handleFetchModelsByMake(categoryId: number, makeId: number) {
      this.loading = true
      this.fetchModelsByMake({ categoryId, makeIds: makeId })
        .then(() => {
          if (
            this.question?.id &&
            categoryId === this.question.questionCategory &&
            this.question?.questionMake?.id
          ) {
            this.$refs.qnaForm.setMakeAndModel(this.question)
          }
        })
        .finally(() => (this.loading = false))
    },
    handleFetchAllCategories() {
      this.loading = true
      this.fetchAllCategories().finally(() => (this.loading = false))
    },
    handleFetchMakesByCategoryId(categoryId: number) {
      this.loading = true
      this.fetchMakesByCategoryId(categoryId).finally(
        () => (this.loading = false)
      )
    },
    handleCreateQuestion(formData: QnaFormData) {
      this.handleFetchMakesByCategoryId(this.selectedCategoryId)
      this.loading = true
      this.createQuestion(formData)
        .then(() => {
          this.$emit('question-created')
        })
        .catch(e => {
          this.scrollToInvalid(1000)
          // this will force load recaptcha 2
          if (e.response?.status === 422) {
            this.onError({ recaptcha_token: true })
          }
          this.qnaService.handleError(e)
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleUpdateQuestion(formData: QnaFormData) {
      this.loading = true
      this.updateQuestion(formData)
        .then(() => this.$emit('question-updated'))
        .catch(e => {
          this.scrollToInvalid(1000)
          if (e.response?.status === 422) {
            this.onError({ recaptcha_token: true })
          }
          this.qnaService.handleError(e)
        })
        .finally(() => (this.loading = false))
    }
  }
})
